import { useQuery, UseQueryOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { SensorsBillingStatsColumn } from 'src/api'
import { useApiInstance } from './useApiInstance'

export interface SensorsBillingStats {
  thingspace?: SensorsBillingStatsColumn
  climit?: SensorsBillingStatsColumn
}

interface RequestParams {
  options?: Omit<UseQueryOptions<SensorsBillingStats, Error>, 'queryKey' | 'queryFn'>
}

export const useSensorsBillingStatsRequest = ({ options }: RequestParams = {}) => {
  const api = useApiInstance()

  return useQuery<SensorsBillingStats, Error>(
    [Entities.SensorBillingStats],
    async () => {
      const { data } = await api.v1AdminSensorsBillingStatsGet()
      return data as SensorsBillingStats
    },
    options
  )
}
